interface ReportTypeToggleProps {
  reportType: "technical_visit" | "delivery";
  dataLoading: boolean;
  onReportTypeChange: (type: "technical_visit" | "delivery") => void;
}

export function ReportTypeToggle({
  reportType,
  dataLoading,
  onReportTypeChange,
}: ReportTypeToggleProps) {
  return (
    <div className="flex justify-start items-center gap-4 mb-6">
      <div className="inline-flex items-center bg-white rounded-full shadow-md border border-gray-200 p-1">
        <button
          onClick={() => onReportTypeChange("technical_visit")}
          disabled={dataLoading}
          className={`px-6 py-2 rounded-full font-medium text-sm transition-all duration-300 ${
            reportType === "technical_visit"
              ? "bg-gradient-to-r from-[#0085BD] to-[#006a96] text-white shadow-lg"
              : "text-gray-600 hover:text-gray-800"
          } disabled:opacity-50 disabled:cursor-not-allowed`}
        >
          Visita Técnica
        </button>
        <button
          onClick={() => onReportTypeChange("delivery")}
          disabled={dataLoading}
          className={`px-6 py-2 rounded-full font-medium text-sm transition-all duration-300 ${
            reportType === "delivery"
              ? "bg-gradient-to-r from-[#0085BD] to-[#006a96] text-white shadow-lg"
              : "text-gray-600 hover:text-gray-800"
          } disabled:opacity-50 disabled:cursor-not-allowed`}
        >
          Entrega
        </button>
      </div>
      {dataLoading && (
        <div className="flex items-center gap-2 text-sm text-gray-500">
          <div className="animate-spin rounded-full h-4 w-4 border-2 border-[#0085BD]/30 border-t-[#0085BD]" />
          <span>Atualizando...</span>
        </div>
      )}
    </div>
  );
}
